import { render } from "./QuickLink.vue?vue&type=template&id=578c1d04&scoped=true"
import script from "./QuickLink.vue?vue&type=script&lang=js"
export * from "./QuickLink.vue?vue&type=script&lang=js"

import "./QuickLink.vue?vue&type=style&index=0&id=578c1d04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578c1d04"]])

export default __exports__